import React from 'react';

const QRCNotActivePage = () => {
  return (
    <div style={styles.container}>
      <img src="/notactive.png" alt="QRC Not Active" style={styles.image} />
      <h1 style={styles.message}>QRC is not active</h1>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#fff',
  },
  image: {
    width: '100%',
    // maxWidth: '300px', // Ensures the image is responsive
    height: 'auto',
    marginBottom: '20px',
  },
  message: {
    fontSize: '24px',
    color: '#333',
    textAlign: 'center',
  },
};

export default QRCNotActivePage;
